<template>
  <v-content class="stamp">
    <SelectedShop v-if="init.branch_flg == 1" :selected_shop_name="selected_shop" :router_param="{ name: 'stamp_shops', query: { feature_id: 'stamp_list'}}" ></SelectedShop>

    <div v-if="item">
    <v-img v-if="item.image_path" :src="item.image_path" lazy-src="@/assets/noimg@2x.png" class="mb-5">
      <template v-slot:placeholder>
        <v-row class="fill-height ma-0" align="center" justify="center">
          <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
        </v-row>
      </template>
    </v-img>
    <v-img v-else src="@/assets/noimg@2x.png" lazy-src="@/assets/noimg@2x.png" class="mb-5">
    </v-img>

    <div class="pa-3">
      <div class="text-center">
        <h1 class="subtitle-1 font-weight-black mb-5 border_maincolor nl2br" style="border-bottom: solid 1px; display: inline-block;">{{item.title}}</h1>
      </div>

      <div class="text-center">
        <v-chip outlined x-small class="mb-2" style="color:#9D9D9D; border-color: #9D9D9D;">{{item.stamp_number}}枚目</v-chip>
        <p class="fontsize11 font-weight-bold" style="color:#9D9D9D;" v-if="item.expiration_date">有効期限：{{item.expiration_date}}</p>
      </div>

      <v-divider class="mb-5"></v-divider>

      <div class="text-center mb-10">
        <div class="fontsize13 nl2br mb-3" v-html="item.headline" v-if="item.headline"></div>
        <!-- <div class="fontsize13 nl2br mb-6" v-html="item.detail" v-if="item.detail"></div> -->
        <p class="fontsize13 mb-0" @click.stop="aboutDialog = true"><v-icon x-small>fas fa-info-circle</v-icon><span style="text-decoration: underline;">{{item.title}}について</span></p>
      </div>

      <!-- ランク表示 -->
      <RankView
        :item="item"
        v-if="item.rank_data"
        ref="rankView"
        @openDialog="showRankDialog"
      ></RankView>

      <div class="text-center mb-12">
        <v-btn v-if="item.auto_flg == 0" rounded class="maincolor-bg default_button mb-10 title w70" @click.stop="toStampAuth(item.id, item.auth_type, item.shop_id)">STAMP GET</v-btn>

        <v-btn v-if="item.is_complete_ticket == 1" rounded class="maincolor-btn2 default_button btn_small body-2" style="background-color:#EFEFEF;" @click.stop="routerBindTo({ name: 'stamp_bonuslist', query: { stamp_id: item.id, shop_id: item.shop_id}})">獲得済みチケットを見る</v-btn>
        <v-btn v-else rounded disabled class="maincolor-btn default_button btn_small body-2" style="background-color:#EFEFEF;">獲得済みチケットを見る</v-btn>
      </div>

      <v-divider class="my-5"></v-divider>

      <v-card v-for="(stamp, index) in item.stamp_data" :key="index" class="mb-10">
        <!-- NEW_DEV-2010 cyber start -->
        <v-img height="103" class="white--text align-center text-center mb-1">
          <v-img v-if="stamp.ticket_img_path" :src="stamp.ticket_img_path" lazy-src="@/assets/noimg@2x.png" height="103" >
          <template v-slot:placeholder>
          <v-row class="fill-height ma-0" align="center" justify="center">
            <v-progress-circular indeterminate color="grey lighten-5"></v-progress-circular>
          </v-row>
          </template>
          </v-img>
          <v-img v-else src="@/assets/noimg@2x.png" lazy-src="@/assets/noimg@2x.png" height="103"></v-img>
        <!-- NEW_DEV-2010 cyber end -->
        <v-overlay absolute opacity="0.5">
        <v-card-subtitle v-if="stamp.last_flg == 0" class="white--text pa-0">スタンプ{{stamp.complete_number}}個取得特典</v-card-subtitle>
        <v-card-subtitle v-else class="white--text pa-0">コンプリート特典</v-card-subtitle>
        <v-card-title class="text-center pa-2 subtitle-1 font-weight-bold" style="display: block; line-height: 20px">{{stamp.ticket_title}}</v-card-title>
        </v-overlay>
        </v-img>

        <v-expansion-panels :value="isExpand[index] = 0" v-model="isExpand[index]">
          <v-expansion-panel>
          <v-expansion-panel-header class="stampPanelIcon" style="padding: 8px 24px; min-height: inherit;">
            <template v-slot:actions>
              <v-icon class="maincolor">fas fa-chevron-down</v-icon>
            </template>
          </v-expansion-panel-header>
          <p style="text-align:center; font-size:0.875rem" v-if="stampCompleteTextFlg[index]">特典GETまであと{{calcStamp(stamp.count, stamp.complete_number)}}個</p>

          <v-expansion-panel-content style="padding: 0 0 0;">
            <div class="text-center mb-0 px-1 pb-0">
              <v-row no-gutters class="justify-space-between align-start">
                <div class="mb-3" v-for="(stampnum, i) in stamp.stamps" :key="i">
                  <v-avatar :color="$root.maincolorop" size="66">
                    <img v-if="stampnum.image_path" :src="stampnum.image_path">
                    <v-icon v-else class="maincolor">fas fa-check</v-icon>
                  </v-avatar>
                  <p class="fontsize11 maincolor text-center">{{stampnum.get_date}}</p>
                </div>

                <div class="mb-3" v-for="(val, key) in empty_stamps[index]" :key="key">
                  <v-avatar color="#F4F4F4" size="66">
                    <span class="title" style="color:#DEDEDF;">{{val}}</span>
                  </v-avatar>
                  <p class="fontsize11 maincolor text-center"></p>
                </div>
              </v-row>
            </div>
          </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-card>
    </div>

    <div v-if="item.memo_flg">
      <div class="memotitlebar px-3 py-2 mb-6">
        <h3 class="body-2">次回来店予定メモ</h3>
      </div>

      <v-row no-gutters class="px-3 justify-space-between align-center" v-if="item.memo_data">
        <v-col cols="3">
          <p class="fontsize11 font-weight-bold" style="color:#9D9D9D;">来店予定日</p>
        </v-col>
        <v-col cols="9">
          <p class="fontsize13">{{item.memo_data.memo_date}}</p>
        </v-col>

        <v-col cols="3">
          <p class="fontsize11 font-weight-bold" style="color:#9D9D9D;">時間</p>
        </v-col>
        <v-col cols="9">
          <p class="fontsize13">{{item.memo_data.memo_time}}</p>
        </v-col>

        <v-col cols="3" class="align-self-start">
          <p class="fontsize11 font-weight-bold" style="color:#9D9D9D;">メモ</p>
        </v-col>
        <v-col cols="9" class="align-self-start">
          <p class="fontsize13">{{item.memo_data.memo}}</p>
        </v-col>
      </v-row>

      <v-row no-gutters class="mb-10 px-3 justify-space-between align-center">
        <v-col cols="6" class="text-center">
          <v-btn v-if="item.memo_data" rounded depressed class="maincolor-btn2 default_button btn_small subtitle-2 w90" @click.stop="routerBindTo({ name: 'stamp_memolist', query: { stamp_id: item.id, shop_id: item.shop_id}})">過去のメモ一覧</v-btn>
          <v-btn v-else disabled rounded depressed class="maincolor-btn2 default_button btn_small subtitle-2 w90" style="background-color:#EFEFEF;" @click.stop="routerBindTo({ name: 'stamp_memolist', query: { stamp_id: item.id, shop_id: item.shop_id}})">過去のメモ一覧</v-btn>
        </v-col>
        <v-col cols="6" class="text-center">
          <v-btn rounded depressed class="maincolor-bg default_button btn_small subtitle-2 w90" @click.stop="routerBindTo({ name: 'memo_regist', query: { stamp_id: item.id, shop_id: item.shop_id}})">メモを編集する</v-btn>
        </v-col>
      </v-row>
    </div>

    <div class="text-center">
      <v-btn rounded class="mb-10 maincolor-bg default_button" @click="routerBindTo({ name: 'stamp_list', params: { shop_id: init.shop_id}})">スタンプ一覧に戻る</v-btn>
    </div>

    <!-- スタンプカードについてダイアログ -->
    <v-dialog v-model="aboutDialog" persistent>
      <v-card class="ticket_dialogue pa-3">
        <h4 class="subtitle-1 font-weight-bold">スタンプカードについて</h4>
        <v-divider class="my-2"></v-divider>
        <p class="caption mb-10" v-html="item.detail.replace(/\n/g,'<br/>')"></p>

        <h4 class="subtitle-1 font-weight-bold">対象店舗一覧</h4>
        <v-divider class="my-2"></v-divider>
        <p class="caption mb-10">
          {{item.shop_name}}
        </p>

        <h4 class="subtitle-1 font-weight-bold">お使いのスマートフォンについて</h4>
        <v-divider class="my-2"></v-divider>
        <p class="caption mb-10">
          現在ご使用中のスマートフォンにて機種変更ならびにアプリの再インストールをお考えのお客様へ、以下の場合は現在取得しているスタンプを引き継ぐことが可能となります。<br>
          <br>
          お使いの機種と同じOS端末への変更の場合は、情報の引き継ぎが可能です。<br>
          <br>
          お使いの機種から異なるOSの端末へ変更する場合は、アプリのレギュレーションにより取得情報の引き継ぎができません。<br>
          異なるOS間でもアプリ自体は変わらずご利用いただけます。
        </p>

        <div class="text-center">
          <v-btn rounded depressed class="caption font-weight-black mb-10 w80" style="background-color:#EFEFEF;" @click="aboutDialog = false">閉じる</v-btn>
        </div>
      </v-card>
    </v-dialog>

    <!-- ランクについてダイアログ -->
    <RankDialog :item="ranks" :init="init" ref="rankDialog" v-if="ranks"></RankDialog>

    <!-- ランクアップダイアログ -->
    <!-- ネイティブ側で表示するため、不要
    <RankUpDialog :data="ranks" :item="item" ref="rankUpDialog"></RankUpDialog>
    -->
    </div>
  </v-content>
</template>

<script>
import SelectedShop from '@/components/selected_shop.vue'
import RankView from "@/views/stamp/RankView.vue";
import RankDialog from "@/views/stamp/RankDialog.vue";
// import RankUpDialog from "@/views/stamp/RankUpDialog.vue";
export default {
  components: {
    SelectedShop,
    RankView,
    RankDialog,
    //RankUpDialog,
  },
  data: () => ({
    isExpand: [],
    stampCompleteTextFlg: [],
    selected_shop: 'すべて',
    aboutDialog: false,
    rankDialog: false,
    init: [],
    item: [],
    ranks: null,
    num: null,
    start_card_num: [0],
    empty_stamps: [],
  }),
  watch: {
    isExpand: {
      deep:true,
      handler: function () {
        this.isExpand.forEach((item, i) => {
            this.stampCompleteTextFlg[i] = typeof item === 'undefined' ? true : false;
        });
      }
    }
  },
  async created () {
    // GET パラメータを取得
    this.getUrlParam()

    //createdで、localstrageから全ての保存情報を取得しinitに格納
    this.init = this.storageGet('*')

    var params = {
      'stamp_id': this.init.stamp_id,
      'shop_id': this.init.shop_id,
      'preview':  this.getUrlGetParam('preview')
    }
    // 2021/02/02 NEW_DEV-1388 秦 Start
    if (this.init.selected_shop) {
      this.selected_shop = this.init.selected_shop
    }
    // 2021/02/02 NEW_DEV-1388 秦 End
    try{
      // スタンプ詳細API
      var res = await this.apiCall('/stamp/detail', {params: params}, 'get');
      if (!res) return false;
      this.$set(this, 'item', res.data);

      var start = 1;
      var tmpArray = null;
      if(this.item.stamp_data){
        this.item.stamp_data.forEach((value) => {
          this.start_card_num.push(value.complete_number);
          tmpArray = [];
          for (let i = start; i <= value.complete_number; i++) {
            start++;
            if (value.count < i) {
              tmpArray.push(i);
            }
          }
          this.empty_stamps.push(tmpArray);
        })
      }

      // スタンプランクAPI
      if(this.item.rank_data){
        var rank_res = await this.apiCall('/stamp/get-rank', params, 'post');
        if (!rank_res) return false;
        this.$set(this, 'ranks', rank_res);

        /* ネイティブ側でランクアップダイアログは表示するため、不要
        if (this.ranks.rankuped == 1) { //ランクアップしていた場合、ランクアップダイアログを表示
            this.$refs.rankUpDialog.open()
        }
        */
      }

    } catch(e) {
        this.callDialog('通信エラー', 'ネットワークの状態が不安定です。再度お試しください', 3);
    }
  },
  methods: {
    noStampCount: function (compnumber, stampNum) {
      return compnumber - stampNum
    },
    showRankDialog() {
      this.$refs.rankDialog.open();
    },
    toStampAuth(id, auth_type, shop_id){
      this.loading = true
      var destination = null
      var screenID = null
      switch (auth_type) {
        case 1:
          destination = 'stampAuthCodeActivity'
          screenID = 'stamp_auth_code'
          break;
        case 2:
          destination = 'stampAuthQrActivity'
          screenID = 'stamp_auth_qr'
          break;
        case 3:
          destination = 'stampAuthBeaconActivity'
          screenID = 'stamp_auth_beacon'
          break;
        case 4:
          destination = 'stampAuthWifiActivity'
          screenID = 'stamp_auth_wifi'
          break;
        default:
          // 20210203 NEW_DEV-1407 cyber start
          destination = 'stampAuthCodeActivity'
          screenID = 'stamp_auth_code'
          break;
          // 20210203 NEW_DEV-1407 cyber start
      }
      var tonative_req = {
        'destination': destination,
        'feature_id': 'stamp',
        'screen_id': screenID,
        'transition_type': 3,
        'stamp_id': id,
        'shop_id': shop_id,
        //暫定対応
        'top_type': 1,
        'cassette_id': 1
      };

      if (!(this.screenTransition(tonative_req))) {
        this.loading = false
        this.callDialog('遷移エラー', '遷移情報が不正です。再度アクセスして下さい。', 2);
      }else{
        this.loading = false
      }
    },
    calcStamp(current, complete) {
      if (current > complete) {
          return 0;
      }

      return complete - current;
    }
  }
}
</script>

<style scoped>
.memotitlebar {
  background-color: #E4E4E4;
  color: #000;
  font-weight: bold;
}
</style>
<style>
.stampPanelIcon div {
  margin: auto !important;
}
</style>
